import _objectSpread from "/home/gitlab-runner/builds/9dQn4WFF/0/digitraffic-sas/construcaribe-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/gitlab-runner/builds/9dQn4WFF/0/digitraffic-sas/construcaribe-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["bsPrefix", "className", "children", "label", "as", "onClick"];
import classNames from 'classnames';
import * as React from 'react';
import { useContext } from 'react';
import useEventCallback from '@restart/hooks/useEventCallback';
import { useBootstrapPrefix } from './ThemeProvider';
import NavbarContext from './NavbarContext';
import { jsx as _jsx } from "react/jsx-runtime";
var defaultProps = {
  label: 'Toggle navigation'
};
var NavbarToggle = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
    className = _ref.className,
    children = _ref.children,
    label = _ref.label,
    _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'button' : _ref$as,
    onClick = _ref.onClick,
    props = _objectWithoutProperties(_ref, _excluded);
  bsPrefix = useBootstrapPrefix(bsPrefix, 'navbar-toggler');
  var _ref2 = useContext(NavbarContext) || {},
    onToggle = _ref2.onToggle,
    expanded = _ref2.expanded;
  var handleClick = useEventCallback(function (e) {
    if (onClick) onClick(e);
    if (onToggle) onToggle();
  });
  if (Component === 'button') {
    props.type = 'button';
  }
  return /*#__PURE__*/_jsx(Component, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    onClick: handleClick,
    "aria-label": label,
    className: classNames(className, bsPrefix, !expanded && 'collapsed'),
    children: children || /*#__PURE__*/_jsx("span", {
      className: "".concat(bsPrefix, "-icon")
    })
  }));
});
NavbarToggle.displayName = 'NavbarToggle';
NavbarToggle.defaultProps = defaultProps;
export default NavbarToggle;